/* Shared collection grid (sections/hf-collection-grid.liquid): Shopify storefront filters + sort + "Visa fler",
   re-rendered through the Section Rendering API. Events are delegated on the section root because its inner
   HTML is swapped after every filter change. */
(function () {
  /* Variant chips on SQARP family cards (snippets/hf-card.liquid): each family member is its own product, listed
     in the card's .hc-vj JSON with its options in "o". Picking a chip swaps the card to the matching member. */
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function same(a, b) { for (var k in b) if (a[k] !== b[k]) return false; return true; }
  // numeric: "15x68x2100 mm" sorts before "15x120x1800 mm"
  function order(vs) { return vs.sort(function (a, b) { return a.localeCompare(b, 'sv', { numeric: true }); }); }
  var MAXV = 8; // chips per row before a "+N" button, big families would fill the card
  function vpaint(li, cur) {
    var V = li._v, keys = [];
    li._cur = cur;
    V.forEach(function (v) { for (var k in v.o) if (keys.indexOf(k) < 0) keys.push(k); });
    li.querySelector('.hc-vo').innerHTML = keys.map(function (k) {
      var vs = order(V.map(function (v) { return v.o[k]; }).filter(function (x, i, a) { return x && a.indexOf(x) === i; }));
      if (vs.length < 2) return '';
      var more = li._open || vs.length <= MAXV + 1 ? 0 : vs.length - MAXV;
      // keep the selected value visible when the row is cut
      var shown = more ? vs.slice(0, MAXV) : vs;
      if (more && shown.indexOf(cur.o[k]) < 0) shown[MAXV - 1] = cur.o[k];
      return '<div class="hc-vrow"><span class="hc-vl">' + esc(k) + '</span><div class="hc-vv">' + shown.map(function (x) {
        var want = {}; for (var j in cur.o) want[j] = cur.o[j]; want[k] = x;
        var av = V.some(function (v) { return same(v.o, want); });
        return '<button type="button" class="hc-vb' + (av ? '' : ' hc-na') + '" data-k="' + esc(k) + '" data-v="' + esc(x) + '" aria-pressed="' + (cur.o[k] === x) + '">' + esc(x) + '</button>';
      }).join('') + (more ? '<button type="button" class="hc-vb hc-vmore" aria-label="Visa alla ' + vs.length + '">+' + more + '</button>' : '') + '</div></div>';
    }).join('');
    var cmp = li.dataset.cmp === 'true' && cur.off > 0, badge = li.dataset.badge === 'true' && cur.off > 0;
    var img = li.querySelector('.hc-im img');
    if (img && cur.img) { img.removeAttribute('srcset'); img.src = cur.img; }
    li.querySelectorAll('.hc-im, h3 a').forEach(function (a) { a.href = cur.u; });
    li.querySelector('h3 a').textContent = cur.t;
    var b = li.querySelector('.hc-badge');
    if (badge) { if (!b) { b = document.createElement('span'); b.className = 'hc-badge'; li.querySelector('.hc-fig').appendChild(b); } b.textContent = '−' + cur.off + ' %'; }
    else if (b) b.remove();
    var pr = li.querySelector('.hc-pr');
    pr.innerHTML = '<strong>' + esc(cur.p) + '</strong>' + (cmp ? '<s>' + esc(cur.c) + '</s>' : '');
    var sv = li.querySelector('.hc-save');
    if (cmp) { if (!sv) { sv = document.createElement('p'); sv.className = 'hc-save'; pr.after(sv); } sv.textContent = 'Du sparar ' + cur.sv; }
    else if (sv) sv.remove();
    var st = li.querySelector('.hc-stk');
    st.className = 'hc-stk' + (cur.in ? ' hc-in' : ''); st.textContent = cur.in ? 'I lager' : 'Beställningsvara';
    var act = li.querySelector('.hc-bd > form, .hc-bd > a.hc-btn');
    act.outerHTML = cur.add
      ? '<form method="post" action="' + esc(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add' : '/cart/add') + '"><input type="hidden" name="id" value="' + cur.id + '"><input type="hidden" name="quantity" value="1"><button class="hc-btn hc-btn-s" type="submit">Lägg i varukorgen</button></form>'
      : '<a class="hc-btn hc-btn-s" href="' + esc(cur.u) + '">Se produkt</a>';
  }
  function vcards(scope) {
    scope.querySelectorAll('.hc-card[data-hcv]:not([data-hcv-on])').forEach(function (li) {
      li.setAttribute('data-hcv-on', '');
      try { li._v = JSON.parse(li.querySelector('.hc-vj').textContent); } catch (e) { return; }
      if (li._v.length) vpaint(li, li._v[0]);
    });
  }
  function vpick(btn) {
    var li = btn.closest('.hc-card'), k = btn.dataset.k, x = btn.dataset.v, want = {};
    if (btn.classList.contains('hc-vmore')) { li._open = true; vpaint(li, li._cur); return; }
    for (var j in li._cur.o) want[j] = li._cur.o[j];
    want[k] = x;
    // exact match first, else the member with this value that keeps most of the other picks
    var best = null, score = -1;
    li._v.forEach(function (v) {
      if (v.o[k] !== x) return;
      var s = 0; for (var j in want) if (v.o[j] === want[j]) s++;
      if (s > score) { best = v; score = s; }
    });
    if (best) vpaint(li, best);
  }

  function init(root) {
    if (root.dataset.hcgInit) return;
    root.dataset.hcgInit = '1';
    var id = root.dataset.section, busy = null, timer = null;
    var $ = function (s) { return root.querySelector(s); };
    vcards(root);

    function query() {
      var form = $('.hc-flt'), p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      var s = $('.hc-sort'); if (s) p.set('sort_by', s.value);
      var view = new URLSearchParams(location.search).get('view'); if (view) p.set('view', view); // keep alternate templates
      return p;
    }
    function sectionUrl(url) { var u = new URL(url, location.href); u.searchParams.set('section_id', id); return u.toString(); }
    function fetchSection(url) {
      if (busy) busy.abort();
      busy = new AbortController();
      root.classList.add('hc-loading');
      return fetch(sectionUrl(url), { signal: busy.signal, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html').querySelector('.hfc-grid'); })
        .finally(function () { root.classList.remove('hc-loading'); });
    }
    function refresh(url) {
      var wasOpen = $('.hc-flt') && $('.hc-flt').classList.contains('hc-open');
      fetchSection(url).then(function (fresh) {
        if (!fresh) { location.href = url; return; }
        root.querySelector('section').innerHTML = fresh.querySelector('section').innerHTML;
        vcards(root);
        if (wasOpen) fltSet(true);
        history.replaceState(null, '', url);
      }).catch(function (e) { if (e.name !== 'AbortError') location.href = url; });
    }
    function apply() { var q = query().toString(); refresh(location.pathname + (q ? '?' + q : '')); }

    function fltSet(on) {
      var f = $('.hc-flt'), b = $('.hc-flt-bd'); if (!f) return;
      f.classList.toggle('hc-open', on); if (b) b.classList.toggle('hc-open', on);
      document.body.style.overflow = on ? 'hidden' : '';
    }

    root.addEventListener('change', function (e) {
      if (!e.target.closest('.hc-flt') && !e.target.classList.contains('hc-sort')) return;
      clearTimeout(timer); timer = setTimeout(apply, e.target.type === 'number' ? 400 : 0);
    });
    root.addEventListener('submit', function (e) { if (e.target.classList.contains('hc-flt')) { e.preventDefault(); apply(); } });
    root.addEventListener('click', function (e) {
      var vb = e.target.closest('.hc-vb');
      if (vb) { vpick(vb); return; }
      var t = e.target.closest('[data-hcg-tile],[data-hcg-clear],[data-hcg-more],.hc-flt-btn,.hc-flt-close,.hc-flt-apply,.hc-flt-bd');
      if (!t) return;
      if (t.matches('[data-hcg-tile]')) {
        var box = Array.prototype.find.call(root.querySelectorAll('.hc-flt input[type=checkbox]'), function (i) {
          return i.name === t.dataset.hcgTile && i.value === t.dataset.v;
        });
        if (box) { box.checked = !box.checked; apply(); }
      }
      else if (t.matches('[data-hcg-clear]')) { e.preventDefault(); refresh(t.getAttribute('href')); }
      else if (t.matches('[data-hcg-more]')) {
        e.preventDefault();
        var next = t.getAttribute('href');
        t.textContent = 'Laddar…';
        fetchSection(next).then(function (fresh) {
          if (!fresh) { location.href = next; return; }
          var grid = $('.hc-grid');
          fresh.querySelectorAll('.hc-grid > .hc-card').forEach(function (li) { grid.appendChild(li); });
          vcards(grid);
          var more = $('.hc-more'), freshMore = fresh.querySelector('.hc-more');
          if (freshMore) more.replaceWith(freshMore); else more.remove();
          var bar = $('.hc-bar-c'), freshBar = fresh.querySelector('.hc-bar-c');
          if (bar && freshBar) {
            // the fresh page counts only its own offset; show the running total instead
            var total = freshBar.textContent.match(/av\s+(\d+)/);
            bar.textContent = 'Visar ' + grid.querySelectorAll('.hc-card').length + ' av ' + (total ? total[1] : '') + ' produkter';
          }
        }).catch(function (err) { if (err.name !== 'AbortError') location.href = next; });
      }
      else if (t.matches('.hc-flt-btn')) fltSet(true);
      else if (t.matches('.hc-flt-close,.hc-flt-bd')) fltSet(false);
      else if (t.matches('.hc-flt-apply')) { fltSet(false); $('.hc-grid').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fltSet(false); });
  }
  function boot() { document.querySelectorAll('.hfc-grid').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.hfc-grid'); if (r) init(r); });
})();
